module.exports = __webpack_public_path__ + "img/mobilepay.4da4aaf.svg";